import { IonButton, IonButtons, IonIcon, useIonAlert } from "@ionic/react";
import { logOutOutline } from "ionicons/icons";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { LocalStorageService } from "../../services/localStorageService";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { resetUserClaims } from "../../redux/reducers/signup/claims";
import { resetuserSignupForm } from "../../redux/reducers/signup/form";
import { resetAddRequestForm } from "../../redux/reducers/request/create/form";
import { resetDetailsRequestForm } from "../../redux/reducers/request/detail/form";
import { resetRequestList } from "../../redux/reducers/request/list/list";
import { unregisterUserNotificationAction } from "../../redux/actions/user/user";

export const LogoutUser = () => {
    const { t } = useTranslation("common");
    const [presentAlert] = useIonAlert();
    const history = useHistory();
    const localStorage = new LocalStorageService();
    const dispatch = useAppDispatch();
    const { isRegisteredToken } = useAppSelector((state) => state.globalLoading);

    const onClick = () => {
        isRegisteredToken && dispatch(unregisterUserNotificationAction());
        localStorage.clear();
        dispatch(resetUserClaims());
        dispatch(resetuserSignupForm());
        dispatch(resetAddRequestForm());
        dispatch(resetDetailsRequestForm());
        dispatch(resetRequestList());
        return history.push("/");
    };
    const confirm = () => {
        presentAlert({
            header: t("MESSAGES.LOGOUT"),
            cssClass: "custom-alert",
            backdropDismiss: false,
            buttons: [
                {
                    text: t("GLOBAL.CANCEL"),
                    role: "cancel",
                    handler: () => {},
                },
                {
                    text: t("GLOBAL.CLOSE_SESSION"),
                    role: "confirm",
                    cssClass: "alert-button-confirm",

                    handler: () => {
                        onClick();
                    },
                },
            ],
        });
    };
    return (
        <IonButtons slot="end">
            <IonButton onClick={confirm}>
                <IonIcon
                    size="large"
                    icon={logOutOutline}
                ></IonIcon>
            </IonButton>
        </IonButtons>
    );
};
